export const APP_NAME: string = import.meta.env.VITE_APP_NAME || 'inCTRL Professional'
export const APP_ENV: string = import.meta.env.VITE_APP_ENV || import.meta.env.MODE
export const API_URL: string = import.meta.env.VITE_API_URL
export const BROADCAST_URL: string = import.meta.env.VITE_BROADCAST_URL

export const apiOrigin = (): string => new URL(API_URL).origin

export const MESSAGING_API_URL: string = `${apiOrigin()}/api/v1/messaging`

/** Realtime is opt-in; see src/boot/providers/echo.ts. */
export const PUSHER = {
  enabled: import.meta.env.VITE_ECHO_ENABLED === 'true',
  key: import.meta.env.VITE_PUSHER_APP_KEY || 'app-key',
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'app-cluster',
  host: import.meta.env.VITE_PUSHER_APP_HOST || 'localhost',
  port: Number(import.meta.env.VITE_PUSHER_APP_PORT) || 6001,
  forceTLS: import.meta.env.VITE_PUSHER_FORCE_TLS === 'true',
} as const

export const DEV_TOOLS: boolean = import.meta.env.DEV || import.meta.env.MODE === 'e2e'
/** Sentry initialises only when a DSN is present; see boot/plugins/sentry.ts. */
export const SENTRY_DSN: string = import.meta.env.VITE_SENTRY_DSN || ''

/** The v1 professional portal; empty hides the link to it. */
export const LEGACY_PORTAL_URL: string = import.meta.env.VITE_LEGACY_PORTAL_URL || ''

export const TICKET_API_URL: string = (import.meta.env.VITE_TICKET_API_URL || '').replace(
  /\/+$/,
  '',
)
export const SUPPORT_ENABLED: boolean = TICKET_API_URL !== ''

export const MCP_GATEWAY_URL: string = (import.meta.env.VITE_MCP_GATEWAY_URL || '').replace(
  /\/+$/,
  '',
)
export const MCP_GATEWAY_CALLBACK_URL: string = `${MCP_GATEWAY_URL}/callback`
